
import { light_mode, set_admin, set_balance, set_decimal, set_from, set_limit, set_mode, set_netowrks, set_networkPairs, set_sidebarStatus, splash_loading_status } from "../Utility/constants";
import { checkMode, checkSidebarStatus } from "../Utility/helpers";

const initialState = {
    acc: "",
    networks: {},
    networkPairs: {},
    limit: 0,
    balance: 0,
    dec: 0,
    from: "",
    mode: checkMode() ? checkMode() : light_mode,
    sidebarStatus: checkSidebarStatus() ? checkSidebarStatus() : false,
    splashLoading: false,
    swapLoading: false
}

const Reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case set_admin:
            return { ...state, acc: actions.payLoad }
        case set_netowrks:
            return { ...state, networks: { ...actions.payLoad } }
        case set_networkPairs:
            return { ...state, networkPairs: { ...actions.payLoad } }
        case set_balance:
            return { ...state, balance: actions.payLoad }
        case set_limit:
            return { ...state, limit: actions.payLoad }
        case set_decimal:
            return { ...state, dec: actions.payLoad }
        case set_from:
            return { ...state, from: actions.payLoad }
        case set_mode:
            return { ...state, mode: actions.payLoad }
        case set_sidebarStatus:
            return { ...state, sidebarStatus: actions.payLoad }
        case splash_loading_status:
            return { ...state, splashLoading: actions.payLoad }
        case "SWAP_LOADING":
            return { ...state, swapLoading: actions.payLoad }
        default:
            return { ...state }
    }
}



export default Reducer